import Decimal from 'decimal.js'

export const getAssignedAmount = (bookings) => {
  const rawAssignedAmount = bookings.reduce((assignedAmount, transaction) => {
    const { bookingAmount } = transaction

    return assignedAmount.plus(bookingAmount)
  }, new Decimal(0))

  return rawAssignedAmount.toDP(2).toNumber()
}

export default getAssignedAmount
